"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstimatingDashboardSearchResponse = void 0;
const common_1 = require("../../../common");
const estimating_dashboard_data_response_1 = require("./estimating-dashboard-data.response");
class EstimatingDashboardSearchResponse extends common_1.PaginatedResponse {
}
exports.EstimatingDashboardSearchResponse = EstimatingDashboardSearchResponse;
//# sourceMappingURL=estimating-dashboard-search.response.js.map